// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import providerTransitionCompositeView  from '../../../../templates/CCM/ProviderTransition/providerTransitionComposIteView';
import ProviderTransitionItemView from './ProviderTransitionItemView';

// Internal Dependencies - models/collections
import { ProviderTransitionModel } from './models/ProviderTransitionModel';

export default Marionette.CompositeView.extend({

	className: 'enrolled-composite-view',

	childViewContainer: '.patient-list-container',

	childView: ProviderTransitionItemView,

	events: {
		'click .clear-search': 'resetSearch',
	},

	initialize: function(options) {
		this.callback = options.callback;
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.currentPage = 0;
		this.pageSize = 20;

		let searchObj = {
			placeholder: 'Search first name, last name, or PID'
		}

		this.channel.trigger( 'show:search', searchObj, this.collection );

		this.app.ccm_controller.getProviderTransitionList();
		this.collection.loading = true;
		this.listenTo( this.channel, 'set:patientList', this.setEnrolledPatients );
		this.listenTo( this.channel, 'reset:currentPage', this.resetCurrentPage );
		this.listenTo( this.channel, 'rerender', this.render );
		this.listenTo( this.collection, 'update', this.render );
		this.listenTo( this.channel, 'set:selectedProviderId', this.getEnrolledPatients );
		this.listenTo( this.channel, 'set:selectedProgramType', this.getEnrolledPatients );

		this.channel.reply( 'currentPage', () => {
			return this.currentPage;
		});
		this.channel.reply( 'pageSize', () => {
			return this.pageSize;
		});
		$('.content-container').addClass('widen');
	},

	getTemplate: function() {
		return providerTransitionCompositeView( this.collection );
	},

	getEnrolledPatients: function() {
		this.collection.loading = true;
		this.render();
		this.app.ccm_controller.getEnrolledList( 'reset:currentPage' );
	},

	setEnrolledPatients: function( cashedPatientList = null ) {
		this.collection.loading = false;
		this.render();
		this.collection.reset();
		let enrolledList = this.app.ccm_controller.patientList;
		this.collection.renderNoResults = enrolledList && enrolledList.length ? false : true;
		this.collection.isApcm = this.app.controller.isApcm;
		let search = this.app.ccm_controller.searchInput
		this.collection.search = search ? search.substring( search.lastIndexOf("=") + 1 ) : '';
		this.collection.add( enrolledList );
		!enrolledList.length && this.render();
	},

	resetSearch: function() {
		this.channel.trigger( 'reset:search' );
	},

	resetCurrentPage: function() {
		this.currentPage = 0;
		this.app.ccm_controller.patients.currentPage = this.currentPage;
        this.channel.trigger( 'reset:totals' );
	},

	onDestroy: function() {
		this.channel.trigger( 'remove:search' );
		this.app.ccm_controller.clearValue( 'enrolled' );
		this.app.ccm_controller.clearValue( 'sortedBy' );
		$('.content-container').removeClass('widen');
	},

});
